import { render, staticRenderFns } from "./EWMerchantRegistrationApprovedList.vue?vue&type=template&id=ac5fdd72&"
import script from "./EWMerchantRegistrationApprovedList.vue?vue&type=script&lang=js&"
export * from "./EWMerchantRegistrationApprovedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports